(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('apollo-link'), require('apollo-utilities'), require('graphql-anywhere/lib/async')) :
	typeof define === 'function' && define.amd ? define(['exports', 'apollo-link', 'apollo-utilities', 'graphql-anywhere/lib/async'], factory) :
	(factory((global['apollo-link-rest'] = {}),global.apolloLink.core,global.apollo.utilities,global.graphqlAnywhere.async));
}(this, (function (exports,apolloLink,apolloUtilities,async) { 'use strict';

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = undefined;
var popOneSetOfArrayBracketsFromTypeName = function (typename) {
    var noSpace = typename.replace(/\s/g, '');
    var sansOneBracketPair = noSpace.replace(/\[(.*)\]/, function (str, matchStr, offset, fullStr) {
        return (((matchStr != null && matchStr.length) > 0 ? matchStr : null) || noSpace);
    });
    return sansOneBracketPair;
};
var addTypeNameToResult = function (result, __typename, typePatcher) {
    if (Array.isArray(result)) {
        var fixedTypename_1 = popOneSetOfArrayBracketsFromTypeName(__typename);
        return result.map(function (e) { return addTypeNameToResult(e, fixedTypename_1, typePatcher); });
    }
    return typePatcher(result, __typename, typePatcher);
};
var quickFindRestDirective = function (field) {
    if (field.directives && field.directives.length) {
        return field.directives.find(function (directive) { return 'rest' === directive.name.value; });
    }
    return null;
};
function findRestDirectivesThenInsertNullsForOmittedFields(resultKey, current, mainDefinition, fragmentMap, currentSelectionSet) {
    if (current == null || currentSelectionSet == null) {
        return current;
    }
    currentSelectionSet.selections.forEach(function (node) {
        if (apolloUtilities.isInlineFragment(node)) {
            findRestDirectivesThenInsertNullsForOmittedFields(resultKey, current, mainDefinition, fragmentMap, node.selectionSet);
        }
        else if (node.kind === 'FragmentSpread') {
            var fragment = fragmentMap[node.name.value];
            findRestDirectivesThenInsertNullsForOmittedFields(resultKey, current, mainDefinition, fragmentMap, fragment.selectionSet);
        }
        else if (apolloUtilities.isField(node)) {
            var name_1 = apolloUtilities.resultKeyNameFromField(node);
            if (name_1 === resultKey && quickFindRestDirective(node) != null) {
                insertNullsForAnyOmittedFields(current, mainDefinition, fragmentMap, node.selectionSet);
            }
            else {
                findRestDirectivesThenInsertNullsForOmittedFields(resultKey, current, mainDefinition, fragmentMap, node.selectionSet);
            }
        }
        else {
            return (function (node) {
                throw new Error('Unhandled Node Type in SelectionSetNode.selections');
            })(node);
        }
    });
    return current;
}
function insertNullsForAnyOmittedFields(current, mainDefinition, fragmentMap, currentSelectionSet) {
    if (current == null || currentSelectionSet == null) {
        return;
    }
    if (Array.isArray(current)) {
        current.forEach(function (c) {
            return insertNullsForAnyOmittedFields(c, mainDefinition, fragmentMap, currentSelectionSet);
        });
        return;
    }
    currentSelectionSet.selections.forEach(function (node) {
        if (apolloUtilities.isInlineFragment(node)) {
            insertNullsForAnyOmittedFields(current, mainDefinition, fragmentMap, node.selectionSet);
        }
        else if (node.kind === 'FragmentSpread') {
            var fragment = fragmentMap[node.name.value];
            insertNullsForAnyOmittedFields(current, mainDefinition, fragmentMap, fragment.selectionSet);
        }
        else if (apolloUtilities.isField(node)) {
            var value = current[node.name.value];
            if (node.name.value === '__typename') {
            }
            else if (typeof value === 'undefined') {
                current[node.name.value] = null;
            }
            else if (value != null &&
                typeof value === 'object' &&
                node.selectionSet != null) {
                insertNullsForAnyOmittedFields(value, mainDefinition, fragmentMap, node.selectionSet);
            }
            else {
            }
        }
        else {
            return (function (node) {
                throw new Error('Unhandled Node Type in SelectionSetNode.selections');
            })(node);
        }
    });
}
var getURIFromEndpoints = function (endpoints, endpoint) {
    return (endpoints[endpoint || DEFAULT_ENDPOINT_KEY] ||
        endpoints[DEFAULT_ENDPOINT_KEY]);
};
var replaceParam = function (endpoint, name, value) {
    if (value === undefined || name === undefined) {
        return endpoint;
    }
    return endpoint.replace(":" + name, value);
};
var noMangleKeys = ['__typename'];
var convertObjectKeys = function (object, __converter, keypath) {
    if (keypath === void 0) { keypath = []; }
    var converter = null;
    if (__converter.prototype.arity != 2) {
        converter = function (name, keypath) {
            return __converter(name);
        };
    }
    else {
        converter = __converter;
    }
    if (object == null || typeof object !== 'object') {
        return object;
    }
    if (Array.isArray(object)) {
        return object.map(function (o, index) {
            return convertObjectKeys(o, converter, keypath.concat([String(index)]));
        });
    }
    return Object.keys(object).reduce(function (acc, key) {
        var value = object[key];
        if (noMangleKeys.indexOf(key) !== -1) {
            acc[key] = value;
            return acc;
        }
        var nestedKeyPath = keypath.concat([key]);
        acc[converter(key, nestedKeyPath)] = convertObjectKeys(value, converter, nestedKeyPath);
        return acc;
    }, {});
};
var noOpNameNormalizer = function (name) {
    return name;
};
var normalizeHeaders = function (headers) {
    if (headers instanceof Headers) {
        return headers;
    }
    else {
        return new Headers(headers);
    }
};
var concatHeadersMergePolicy = function () {
    var headerGroups = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        headerGroups[_i] = arguments[_i];
    }
    return headerGroups.reduce(function (accumulator, current) {
        if (!current) {
            return accumulator;
        }
        if (!current.forEach) {
            current = normalizeHeaders(current);
        }
        current.forEach(function (value, key) {
            accumulator.append(key, value);
        });
        return accumulator;
    }, new Headers());
};
var overrideHeadersMergePolicyHelper = function (linkHeaders, headersToOverride, requestHeaders) {
    var result = new Headers();
    linkHeaders.forEach(function (value, key) {
        if (headersToOverride.indexOf(key) !== -1) {
            return;
        }
        result.append(key, value);
    });
    return concatHeadersMergePolicy(result, requestHeaders || new Headers());
};
var makeOverrideHeadersMergePolicy = function (headersToOverride) {
    return function (linkHeaders, requestHeaders) {
        return overrideHeadersMergePolicyHelper(linkHeaders, headersToOverride, requestHeaders);
    };
};
var validateRequestMethodForOperationType = function (method, operationType) {
    switch (operationType) {
        case 'query':
            if (method.toUpperCase() !== 'GET') {
                throw new Error("A \"query\" operation can only support \"GET\" requests but got \"" + method + "\".");
            }
            return;
        case 'mutation':
            if (['POST', 'PUT', 'PATCH', 'DELETE'].indexOf(method.toUpperCase()) !== -1) {
                return;
            }
            throw new Error('"mutation" operations do not support that HTTP-verb');
        case 'subscription':
            throw new Error('A "subscription" operation is not supported yet.');
        default:
            var _exhaustiveCheck = operationType;
            return _exhaustiveCheck;
    }
};
var rethrowServerSideError = function (response, result, message) {
    var error = new Error(message);
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var resolver = function (fieldName, root, args, context, info) { return __awaiter(_this, void 0, void 0, function () {
    var directives, isLeaf, resultKey, exportVariables, currentNode, isNotARestCall, credentials, endpoints, headers, customFetch, operationType, typePatcher, mainDefinition, fragmentDefinitions, fieldNameNormalizer, linkLevelNameDenormalizer, fragmentMap, _a, path, endpoint, pathBuilder, uri, argsWithExport, bothPathsProvided, neitherPathsProvided, pathBuilderState, pathWithParams, _b, method, type_1, bodyBuilder, bodyKey, perRequestNameDenormalizer, body, maybeBody_1, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                directives = info.directives, isLeaf = info.isLeaf, resultKey = info.resultKey;
                exportVariables = context.exportVariables;
                currentNode = (root || {})[resultKey];
                if (root && directives && directives.export) {
                    exportVariables[directives.export.as] = currentNode;
                }
                isNotARestCall = !directives || !directives.rest;
                if (isLeaf || isNotARestCall) {
                    return [2, currentNode];
                }
                credentials = context.credentials, endpoints = context.endpoints, headers = context.headers, customFetch = context.customFetch, operationType = context.operationType, typePatcher = context.typePatcher, mainDefinition = context.mainDefinition, fragmentDefinitions = context.fragmentDefinitions, fieldNameNormalizer = context.fieldNameNormalizer, linkLevelNameDenormalizer = context.fieldNameDenormalizer;
                fragmentMap = apolloUtilities.createFragmentMap(fragmentDefinitions);
                _a = directives.rest, path = _a.path, endpoint = _a.endpoint, pathBuilder = _a.pathBuilder;
                uri = getURIFromEndpoints(endpoints, endpoint);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                argsWithExport = __assign({}, args, exportVariables);
                bothPathsProvided = path != null && pathBuilder != null;
                neitherPathsProvided = path == null && pathBuilder == null;
                if (bothPathsProvided || neitherPathsProvided) {
                    pathBuilderState = bothPathsProvided
                        ? 'both, please remove one!'
                        : 'neither, please add one!';
                    throw new Error("One and only one of (\"path\" | \"pathBuilder\") must be set in the @rest() directive. " +
                        ("This request had " + pathBuilderState));
                }
                if (!pathBuilder) {
                    pathBuilder = function (args) {
                        var pathWithParams = Object.keys(args).reduce(function (acc, e) { return replaceParam(acc, e, args[e]); }, path);
                        if (pathWithParams.includes(':')) {
                            throw new Error('Missing params to run query, specify it in the query params or use an export directive');
                        }
                        return pathWithParams;
                    };
                }
                pathWithParams = pathBuilder(argsWithExport);
                _b = directives.rest, method = _b.method, type_1 = _b.type, bodyBuilder = _b.bodyBuilder, bodyKey = _b.bodyKey, perRequestNameDenormalizer = _b.fieldNameDenormalizer;
                if (!method) {
                    method = 'GET';
                }
                body = null;
                if (-1 === ['GET', 'DELETE'].indexOf(method) &&
                    operationType === 'mutation') {
                    if (!bodyBuilder) {
                        maybeBody_1 = argsWithExport[bodyKey || 'input'];
                        if (!maybeBody_1) {
                            throw new Error('[GraphQL mutation using a REST call without a body]. No `input` was detected. Pass bodyKey, or bodyBuilder to the @rest() directive to resolve this.');
                        }
                        bodyBuilder = function (argsWithExport) {
                            return maybeBody_1;
                        };
                    }
                    body = convertObjectKeys(bodyBuilder(argsWithExport), perRequestNameDenormalizer ||
                        linkLevelNameDenormalizer ||
                        noOpNameNormalizer);
                }
                validateRequestMethodForOperationType(method, operationType || 'query');
                return [4, (customFetch || fetch)("" + uri + pathWithParams, {
                        credentials: credentials,
                        method: method,
                        headers: headers,
                        body: body && JSON.stringify(body),
                    })
                        .then(function (res) {
                        if (res.status >= 300) {
                            rethrowServerSideError(res, res.text(), "Response not successful: Received status code " + res.status);
                        }
                        return res;
                    })
                        .then(function (res) { return res.json(); })
                        .then(function (result) {
                        return fieldNameNormalizer == null
                            ? result
                            : convertObjectKeys(result, fieldNameNormalizer);
                    })
                        .then(function (result) {
                        return findRestDirectivesThenInsertNullsForOmittedFields(resultKey, result, mainDefinition, fragmentMap, mainDefinition.selectionSet);
                    })
                        .then(function (result) { return addTypeNameToResult(result, type_1, typePatcher); })];
            case 2: return [2, _c.sent()];
            case 3:
                error_1 = _c.sent();
                throw error_1;
            case 4: return [2];
        }
    });
}); };
var DEFAULT_ENDPOINT_KEY = '';
var RestLink = (function (_super) {
    __extends(RestLink, _super);
    function RestLink(_a) {
        var uri = _a.uri, endpoints = _a.endpoints, headers = _a.headers, fieldNameNormalizer = _a.fieldNameNormalizer, fieldNameDenormalizer = _a.fieldNameDenormalizer, typePatcher = _a.typePatcher, customFetch = _a.customFetch, credentials = _a.credentials;
        var _this = _super.call(this) || this;
        var fallback = {};
        fallback[DEFAULT_ENDPOINT_KEY] = uri || '';
        _this.endpoints = Object.assign({}, endpoints || fallback);
        if (uri == null && endpoints == null) {
            throw new Error('A RestLink must be initialized with either 1 uri, or a map of keyed-endpoints');
        }
        if (uri != null) {
            var currentDefaultURI = (endpoints || {})[DEFAULT_ENDPOINT_KEY];
            if (currentDefaultURI != null && currentDefaultURI != uri) {
                throw new Error("RestLink was configured with a default uri that doesn't match what's passed in to the endpoints map.");
            }
            _this.endpoints[DEFAULT_ENDPOINT_KEY] == uri;
        }
        if (_this.endpoints[DEFAULT_ENDPOINT_KEY] == null) {
            console.warn('RestLink configured without a default URI. All @rest(…) directives must provide an endpoint key!');
        }
        if (typePatcher == null) {
            _this.typePatcher = function (result, __typename, _2) {
                return __assign({ __typename: __typename }, result);
            };
        }
        else if (!Array.isArray(typePatcher) &&
            typeof typePatcher === 'object' &&
            Object.keys(typePatcher)
                .map(function (key) { return typePatcher[key]; })
                .reduce(function (current, patcher) { return current && typeof patcher === 'function'; }, true)) {
            var table_1 = typePatcher;
            _this.typePatcher = function (data, outerType, patchDeeper) {
                if (Array.isArray(data)) {
                    return data.map(function (d) { return patchDeeper(d, outerType, patchDeeper); });
                }
                var subPatcher = table_1[outerType] || (function (result) { return result; });
                return __assign({ __typename: outerType || data.__typename }, subPatcher(data, outerType, patchDeeper));
            };
        }
        else {
            throw new Error('RestLink was configured with a typePatcher of invalid type!');
        }
        _this.fieldNameNormalizer = fieldNameNormalizer || null;
        _this.fieldNameDenormalizer = fieldNameDenormalizer || null;
        _this.headers = normalizeHeaders(headers);
        _this.credentials = credentials || null;
        _this.customFetch = customFetch;
        return _this;
    }
    RestLink.prototype.request = function (operation, forward) {
        var query = operation.query, variables = operation.variables, getContext = operation.getContext;
        var context = getContext();
        var isRestQuery = apolloUtilities.hasDirectives(['rest'], operation.query);
        if (!isRestQuery) {
            return forward(operation);
        }
        var headersMergePolicy = context.headersMergePolicy;
        if (headersMergePolicy == null &&
            Array.isArray(context.headersToOverride)) {
            headersMergePolicy = makeOverrideHeadersMergePolicy(context.headersToOverride);
        }
        else if (headersMergePolicy == null) {
            headersMergePolicy = concatHeadersMergePolicy;
        }
        var headers = headersMergePolicy(this.headers, context.headers);
        var credentials = context.credentials || this.credentials;
        var queryWithTypename = apolloUtilities.addTypenameToDocument(query);
        var mainDefinition = apolloUtilities.getMainDefinition(query);
        var fragmentDefinitions = apolloUtilities.getFragmentDefinitions(query);
        var operationType = (mainDefinition || {}).operation || 'query';
        var requestContext = {
            headers: headers,
            endpoints: this.endpoints,
            exportVariables: {},
            credentials: credentials,
            customFetch: this.customFetch,
            operationType: operationType,
            fieldNameNormalizer: this.fieldNameNormalizer,
            fieldNameDenormalizer: this.fieldNameDenormalizer,
            mainDefinition: mainDefinition,
            fragmentDefinitions: fragmentDefinitions,
            typePatcher: this.typePatcher,
        };
        var resolverOptions = {};
        return new apolloLink.Observable(function (observer) {
            async.graphql(resolver, queryWithTypename, null, requestContext, variables, resolverOptions)
                .then(function (data) {
                observer.next({ data: data });
                observer.complete();
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
        });
    };
    return RestLink;
}(apolloLink.ApolloLink));

exports.RestLink = RestLink;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bundle.umd.js.map



//////////////////
// WEBPACK FOOTER
// ./~/apollo-link-rest/bundle.umd.js
// module id = 391
// module chunks = 0